
import XButton from 'vux/src/components/x-button/index.vue'

import {
mapState,
mapActions
}
from 'vuex'
import GuideCover from '@/components/guideCover.vue'
import {
myPacket
}
from '@/api/ajax.js'
import {
marquee
} from '@/Mixin/marquee.js'

export default {
name: 'correct',
mixins: [marquee],
data() {
return {
btList: ['获奖记录', '提现记录'],
btIndex: -1,
recordList: [],
myAnswerAmount: {},
translate3dY: 0,
canAmount: 0, // 可提现金额
recordList2: 0,
ttt: 123
}
},
methods: {
toast() {
this.$vux.toast.show({
text: '点击右上角，分享给微信好友吧',
type: 'text',
width: '7rem'
})
},
toWs() {
sessionStorage.goBackUrl = location.href
this.$sa.setSaSession_href(this.$route,'/html/perfect.html#/perfect')
},
tabClick(item, index) {

this.btIndex = index

},
ATM() {
this.$sa.re_activity({
name:'答题拼图',
event_type:'点击提现'
})
if (this.wxUserInfo.userDataStatus < 2) {
this.showCoverAction({
show: true,
type: 4
})
} else {
if (this.canAmount >= 1) {
this.change(true)
myPacket.tixian({
amount: this.canAmount
}).then(res => {
this.change(false)
if (res.data.status != 0) {
this.canAmount = 0
this.showCoverAction({
show: true,
type: 3
})
} else {
this.$vux.toast.show({
text: res.data.message,
type: 'text',
width: '7rem'
})
}

})
} else {
this.$vux.toast.show({
text: '满一元方可提现',
type: 'text',
width: '7rem'
})
}
}

},
...mapActions([
'showCoverAction',
'change'
])
},
computed: {
...mapState({
wxUserInfo: state => state.wxUserInfo
})
},
components: {
XButton,
GuideCover
},
watch: {
btIndex(n, o) {
this.recordList = []
this.destroy()
this.currenTranslateY = 0
if (n > 0) {
myPacket.myDepositRecord().then(res => {
this.recordList = res.data.data







})
} else {
myPacket.myRedRecord().then(res => {
this.recordList = res.data.data







})
}
}
},
filters: {

},
created() {

this.btIndex = 0
if (!sessionStorage.answerShowCover) {
this.showCoverAction({
show: true,
type: 2
})
}
sessionStorage.answerShowCover = true
myPacket.myAnswerAmount().then(res => {
this.myAnswerAmount = res.data
this.canAmount = Math.floor(this.myAnswerAmount.scoreAmount - this.myAnswerAmount.cashAmount)

})

}
}



// WEBPACK FOOTER //
// ./src/page/MyRedPacket/index.vue